<template>
  <generic-modal
    :title="$t('archive.upload files')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div>
      <!-- File uploader -->
      <div class="field">
        <label class="label">{{ $t("archive.select files") }} *</label>
        <generic-uploader
          ref="generic_uploader"
          :idle_label="$t('archive.drop files here')"
          endpoint_url="/archive/file/upload"
          :extra_data="{ expedient_uuid: meta.expedient_uuid }"
          :allow_multiple="true"
          @error="error_uploading"
          @success="success_uploading"
        />
      </div>
    </div>

    <!-- Error handling -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer buttons -->
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  post,
  del,
  get,
  generate_error_message_text,
  confirm_deletion_dialog,
  success_message,
  error_message,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "FileUploadModal",
  components: {
    GenericModal,
    GenericUploader,
    GenericDropdown,
  },
  data() {
    return {
      meta: {},
      error: "",
      uploaded_files: [],
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.expedient_uuid || this.uploaded_files.length === 0;
    },
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    show_modal(expedient_uuid = null) {
      this.set_initial_state();
      this.$refs.generic_modal.show_modal();
      this.meta.expedient_uuid = expedient_uuid;
    },

    save() {
      this.$root.loader(true);

      // Preparar datos para enviar
      const filesData = this.uploaded_files.map((file) => ({
        file_id: file.file_id,
        final_name: file.final_name,
        original_name: file.original_name,
        category_uuid: file.category_uuid,
        description: file.description || "",
        meta: file.meta,
      }));

      const payload = {
        expedient_uuid: this.meta.expedient_uuid,
        files: filesData,
      };

      put("/archive/files", payload)
        .then(() => {
          this.$emit("success");
          success_message(this.$t("archive.files uploaded successfully"));
          this.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        })
        .finally(() => {
          this.$root.loader(false);
        });
    },

    set_initial_state() {
      this.meta = {
        expedient_uuid: null,
      };
      this.uploaded_files = [];
      this.error = "";
      if (this.$refs.generic_uploader) {
        this.$refs.generic_uploader.clear();
      }
    },

    error_uploading(error) {
      console.error(error);
      error_message(this.$t("archive.error uploading file"));
    },

    success_uploading(response) {
      try {
        // Parsear respuesta del servidor
        let serverResponse = JSON.parse(response.serverId);

        // Estructura estándar para archivos subidos
        let fileData = {
          file_id: serverResponse.file.file_id,
          final_name: serverResponse.final_name,
          meta: serverResponse.file.settings,
          original_name: serverResponse.file.name,
          category_uuid: null,
          description: "",
        };

        // Agregar a la lista de archivos subidos
        this.uploaded_files.push(fileData);

        success_message(this.$t("archive.file uploaded successfully"));
      } catch (error) {
        console.error("Error parsing upload response:", error);
        error_message(this.$t("archive.error processing upload"));
      }
    },

    updateFileCategory(fileIndex, category) {
      if (fileIndex >= 0 && fileIndex < this.uploaded_files.length) {
        this.uploaded_files[fileIndex].category_uuid = category.uuid;
      }
    },

    removeFile(fileIndex) {
      if (fileIndex >= 0 && fileIndex < this.uploaded_files.length) {
        this.uploaded_files.splice(fileIndex, 1);
      }
    },

    formatFileSize(bytes) {
      if (!bytes) return "0 B";

      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>
